module.exports = __webpack_public_path__ + "img/demo14.d18f0bb5.jpg";